import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
/* empty css                         */
import { useMemo as r } from "../../../external/preact/hooks/dist/hooks.module.js";
import { useFetch as I } from "../../../hooks/useFetch.js";
import { PayoutData as b } from "../../external/PayoutDetails/components/PayoutData.js";
import w from "../../../hooks/useBalanceAccounts.js";
import { getErrorMessage as E } from "../../utils/getErrorMessage.js";
import { ErrorMessageDisplay as P } from "../ErrorMessageDisplay/ErrorMessageDisplay.js";
import x from "../Typography/Typography.js";
import { TypographyVariant as C } from "../Typography/types.js";
import { useDataOverviewDetailsTitle as N } from "./useDataOverviewDetailsTitle.js";
import { TransactionData as O } from "../../external/TransactionDetails/components/TransactionData/TransactionData.js";
import { useConfigContext as B } from "../../../core/ConfigContext/context.js";
import { EMPTY_OBJECT as d } from "../../../utils/value/constants.js";
const F = {
  transaction: "getTransaction",
  payout: "getPayout"
}, m = (t) => !("data" in t);
function K(t) {
  var s;
  const f = r(() => m(t) ? null : t.data, [t]), n = r(() => m(t) ? t.id : null, [t]), l = B().endpoints[F[t.type]], { hideTitle: D, title: h } = N(t), { data: c, error: i, isFetching: y } = I(
    r(
      () => ({
        fetchOptions: { enabled: !!n && !!l },
        queryFn: async () => {
          const A = t.type === "transaction" ? {
            path: { transactionId: n }
          } : {
            query: { balanceAccountId: n, createdAt: t.date }
          };
          return l(d, { ...A });
        }
      }),
      [n, l, t]
    )
  ), v = t.type === "payout" ? t.id : c == null ? void 0 : c.balanceAccountId, T = t.type === "payout" ? t == null ? void 0 : t.balanceAccountDescription : t == null ? void 0 : t.balanceAccount, { balanceAccounts: a } = w(v, !T), u = r(() => {
    if (i)
      return E(i, "weCouldNotLoadYourTransactions", t.onContactSupport);
  }, [i, t.onContactSupport]), g = m(t) && t.type === "transaction" ? t.extraDetails : d, o = f ?? c;
  return /* @__PURE__ */ e("div", { className: "adyen-pe-overview-details", children: [
    !D && /* @__PURE__ */ e("div", { className: "adyen-pe-overview-details--title", children: /* @__PURE__ */ e(x, { variant: C.TITLE, medium: !0, children: h }) }),
    i && u && /* @__PURE__ */ e("div", { className: "adyen-pe-overview-details--error-container", children: /* @__PURE__ */ e(P, { withImage: !0, ...u }) }),
    t.type === "transaction" && /* @__PURE__ */ e(
      O,
      {
        transaction: o ? {
          ...o || d,
          balanceAccount: (t == null ? void 0 : t.balanceAccount) || (a == null ? void 0 : a[0])
        } : void 0,
        error: !!(i && u),
        isFetching: y,
        extraFields: g
      }
    ),
    t.type === "payout" && o && /* @__PURE__ */ e(
      b,
      {
        balanceAccountId: n,
        payout: o,
        balanceAccountDescription: (t == null ? void 0 : t.balanceAccountDescription) || ((s = a == null ? void 0 : a[0]) == null ? void 0 : s.description),
        isFetching: y
      }
    )
  ] });
}
export {
  K as default
};
